import { persistor } from '../store/store';

const ACCESS_TOKEN_KEY = 'accessToken';
const ID_TOKEN_KEY = 'idToken';
const EMAIL_TOKEN_KEY = 'email';

// Shared (non-namespaced) key that always reflects whoever last completed a
// login across ALL portals. Used by validateSession to detect cross-portal
// session contamination without relying on JWT claim parsing. Exported so
// App.tsx can recognize this key in the browser's cross-tab `storage` event.
export const ACTIVE_SESSION_KEY = 'deckard:active_cognito_username';

export const saveTokens = (
  accessToken: string | undefined,
  idToken: string | undefined
): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken ?? '');
  localStorage.setItem(ID_TOKEN_KEY, idToken ?? '');
};

export const getTokens = (): {
  accessToken: string | null;
  idToken: string | null;
} => {
  return {
    accessToken: localStorage.getItem(ACCESS_TOKEN_KEY),
    idToken: localStorage.getItem(ID_TOKEN_KEY),
  };
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ID_TOKEN_KEY);
};

export const saveEmail = (email: string): void => {
  localStorage.setItem(EMAIL_TOKEN_KEY, email);
};

export const getEmail = (): string | null => {
  return localStorage.getItem(EMAIL_TOKEN_KEY);
};

export const clearEmail = (): void => {
  localStorage.removeItem(EMAIL_TOKEN_KEY);
};

export const saveActiveSession = (cognitoUsername: string): void => {
  localStorage.setItem(ACTIVE_SESSION_KEY, cognitoUsername);
};

export const getActiveSession = (): string | null => {
  return localStorage.getItem(ACTIVE_SESSION_KEY);
};

export const clearActiveSession = (): void => {
  localStorage.removeItem(ACTIVE_SESSION_KEY);
};

export const clearPersistedState = (): Promise<void> => {
  return persistor.purge();
};
